import { createAction, props } from '@ngrx/store';
import { SubDistrictsModel } from '@roi/common/models/province.model';

export const loadSubDistricts = createAction(
  '[Geo] Load SubDistricts',
  props<{ districtId: number }>()
);

export const loadSubDistrictsSuccess = createAction(
  '[Geo] Load SubDistricts Success',
  props<{ subDistricts: SubDistrictsModel[] }>()
);

export const loadSubDistrictsFailure = createAction(
  '[Geo] Load SubDistricts Failure',
  props<{ error: any }>()
);
